import { render, staticRenderFns } from "./qwServiceStaff.vue?vue&type=template&id=277a13dc&scoped=true"
import script from "./qwServiceStaff.vue?vue&type=script&lang=js"
export * from "./qwServiceStaff.vue?vue&type=script&lang=js"
import style0 from "./qwServiceStaff.vue?vue&type=style&index=0&id=277a13dc&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a13dc",
  null
  
)

export default component.exports